import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, Switch, withRouter } from 'react-router-dom';

import { logout } from 'modules/auth';
import PrivateRoute from 'utils/privateRoute';

import Profile from 'pages/Profile';
import Funds from 'pages/Funds';
import Transactions from 'pages/Transactions';
import Branches from 'pages/Branches';
import OutletDetails from 'pages/OutletDetails';
import TransactionGraph from 'pages/TransactionGraph';

class DashboardLayout extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  logout = (e) => {
    e.preventDefault();
    this.props.dispatch(logout());
  };

  render() {
    return (
      <div className="wrapper wrapper--full">
        <div className="main-content">
          <div className="grid">
            <div className="grid__item large--one-quarter medium--one-quarter mb-40">
              <header className="entry-header">
                <nav>
                  <ul className="vertical-nav">
                    <li>
                      <NavLink activeClassName="is-active" to="/profile">
                        Profil
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="is-active" to="/outlets">
                        Outlet
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="is-active" to="/transactions/graph">
                        Riwayat Transaksi
                      </NavLink>
                    </li>
                    <li>
                      <NavLink activeClassName="is-active" to="/funds">
                        Saldo
                      </NavLink>
                    </li>
                    <li>
                      <a href="/logout" onClick={this.logout}>
                        Logout
                      </a>
                    </li>
                  </ul>
                </nav>
              </header>
            </div>

            <div className="grid__item large--nine-twelfths medium--nine-twelfths main-content-right">
              <Switch>
                <PrivateRoute exact path="/" component={Profile} />
                <PrivateRoute path="/profile" component={Profile} />
                <PrivateRoute path="/funds" component={Funds} />
                <PrivateRoute path="/transactions/graph/:interval" component={TransactionGraph} />
                <PrivateRoute path="/transactions/graph" component={TransactionGraph} />
                <PrivateRoute path="/transactions/page/:page" component={Transactions} />
                <PrivateRoute path="/transactions" component={Transactions} />
                <PrivateRoute path="/outlets/details/:id" component={OutletDetails} />
                <PrivateRoute path="/outlets" component={Branches} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(DashboardLayout));



// WEBPACK FOOTER //
// ./src/pages/DashboardLayout/index.js